import { Routes } from '@angular/router';
import { rolesGuard } from '@core/auth';
import { userResolverFn } from './resolvers/user.resolver';

/**
 * Routes configuration for user management functionality.
 *
 * Defines navigation structure for user CRUD operations including:
 * - User list with breadcrumb navigation
 * - User creation page
 * - User edition page with user data resolution
 */
export const routes: Routes = [
	{
		path: '',
		canActivate: [rolesGuard],
		data: {
			breadcrumb: 'USER_LIST.BREADCRUMBS.MAIN',
			roles: ['ROLE_USER_READ']
		},
		children: [
			{
				path: '',
				loadComponent: () =>
					import('./components/user-list/user-list.component').then(
						(c) => c.UserListComponent
					)
			},
			{
				path: 'add',
				canActivate: [rolesGuard],
				data: {
					breadcrumb: 'USER_EDITION.BREADCRUMBS.ADD',
					roles: ['ROLE_USER_CREATE']
				},
				loadComponent: () =>
					import('./components/user-edition/user-edition.component').then(
						(c) => c.UserEditionComponent
					)
			},
			{
				path: ':userId',
				canActivate: [rolesGuard],
				data: {
					breadcrumb: (data: any) => data.value?.username,
					roles: ['ROLE_USER_UPDATE']
				},
				resolve: { value: userResolverFn },
				loadComponent: () =>
					import('./components/user-edition/user-edition.component').then(
						(c) => c.UserEditionComponent
					)
			}
		]
	}
];
